export default __webpack_public_path__ + "assets/images/aea9a0751f35a7e2f14067728c77809c.png";